module.exports = __webpack_public_path__ + "media/images/multiple-f9f3619e06f196978bb29abf2e3fa325.png";